import keys from './keys'

const thingy = (transactionToken, callbacks)=>{
    // Initialize the hosted fields
    //console.log(getComputedStyle(input.style).content)
    const input = document.querySelector('input.nil-sa-elements-input__input');
    const inputContainer = document.querySelector('.nil-sa-templates-payment-style__inputGroup');
    
    const _styles = getComputedStyle(input)
    const styles = {};
    for(let key of Object.keys(keys)){
        const correctedKey = keys[key]
        if(correctedKey){
            styles[correctedKey] = _styles[key]
        }
    }

    styles.margin = '5px'
    styles.width = inputContainer.offsetWidth;

    const response = emergepayFormFields.init({
        // (required) Used to set up each field
        transactionToken,
        // (required) The type of transaction to run
        transactionType: "CreditSaveCard",
        // (optional) Configure which fields to use and the id's of the elements to append each field to
        fieldSetUp: {
            // These fields are valid for credit card transactions
            cardNumber: {
                appendToSelector: "cardNumberContainer",
                useField: true,
                // optional, see styles section above for more information
                styles
            },
            cardExpirationDate: {
                appendToSelector: "expirationDateContainer",
                useField: true,
                // optional, see styles section above for more information
                styles
            },
            cardSecurityCode: {
                appendToSelector: "securityCodeContainer",
                useField: true,
                // optional, see styles section above for more information
                styles
            },
            // These fields are valid for ACH transactions
            // accountNumber: {
            //     appendToSelector: "accountNumberContainer",
            //     useField: true,
            //     // optional, see styles section above for more information
            //     styles
            // },
            // routingNumber: {
            //     useField: false
            // },
            // accountHolderName: {
            //     appendToSelector: "accountHolderNameContainer",
            //     useField: true,
            //     // optional, see styles section above for more information
            //     styles
            // },
            // These fields are valid for all transaction types
            totalAmount: {
                appendToSelector: "amountContainer",
                useField: false,
                // optional, see styles section above for more information
                styles: {}
            },
            externalTranId: { 
                useField: false,
                // optional, see styles section above for more information
                styles: {}
            }
        },
        // (optional) If there is a validation error for a field, the styles set in this object will be applied to the field
        fieldErrorStyles: {
            "border": "none",
            "box-shadow": "0px 0px 4px 1px red"
        },
        // (optional) This callback function will be called when there is a validation error for a field.
        onFieldError: callbacks.onFieldError,
        // (optional) Callback function that gets called after a successful transaction
        onTransactionSuccess: callbacks.onTransactionSuccess,
        // (optional) Callback function that gets called after a failure occurs during the transaction (such as a declined card)
        onTransactionFailure: callbacks.onTransactionFailure
    });

    return response
};

export default thingy


// WEBPACK FOOTER //
// ./components/templates/Payment/processForm.js